export default "__VITE_ASSET__BnergVfY__"